module.exports = __webpack_public_path__ + "static/sagnik-52fe6f321509984952b74ad023bf2366.jpg";